import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

import { Button } from "../ui/button";

// Aviso de versão nova.
//
// O registro está em `registerType: "prompt"`: o service worker baixa a versão
// nova sozinho, mas ela só passa a valer quando todas as abas fecham.
// Instalado como aplicativo, ninguém fecha — a pessoa fica semanas numa versão
// antiga sem saber, e "já corrigi isso" vira uma discussão sem fim.
//
// Aqui ela fica sabendo e recarrega quando quiser: no meio de uma conversa,
// recarregar sozinho seria pior do que a versão velha.

// De quanto em quanto tempo perguntar ao servidor se saiu versão nova. O
// navegador só reconsulta o sw.js numa navegação — e o painel fica aberto o
// dia inteiro sem nenhuma.
const INTERVALO_DE_CHECAGEM = 30 * 60 * 1000;

const AtualizacaoDisponivel = () => {
	const [pronta, setPronta] = useState(false);
	const [atualizar, setAtualizar] = useState(null);

	useEffect(() => {
		let cancelado = false;
		let timer = null;

		// Import dinâmico: o módulo virtual só existe quando o PWA está ativo
		// (não existe em `npm run dev` sem a opção `devOptions`), e um import
		// estático quebraria o desenvolvimento.
		import("virtual:pwa-register")
			.then(({ registerSW }) => {
				if (cancelado) return;

				const atualizarSW = registerSW({
					onNeedRefresh() {
						setPronta(true);
					},
					onRegisteredSW(url, registro) {
						if (!registro) return;

						timer = setInterval(() => {
							// Offline o `update()` rejeita; sem o catch vira
							// "unhandled rejection" no console a cada 30 min.
							registro.update().catch(() => {});
						}, INTERVALO_DE_CHECAGEM);
					},
				});

				setAtualizar(() => atualizarSW);
			})
			.catch(() => {
				// Sem service worker (desenvolvimento, navegador antigo) não há
				// atualização a avisar. Não é erro.
			});

		return () => {
			cancelado = true;
			if (timer) clearInterval(timer);
		};
	}, []);

	if (!pronta) return null;

	return (
		<div
			role="status"
			className="fixed inset-x-3 bottom-[calc(4.5rem+env(safe-area-inset-bottom))] z-50 flex items-center gap-3 rounded-xl border bg-card p-3 shadow-lg md:inset-x-auto md:right-4 md:bottom-4 md:max-w-sm"
		>
			<div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
				<RefreshCw className="h-4 w-4" />
			</div>
			<div className="min-w-0 flex-1">
				<p className="text-sm font-medium">Nova versão disponível</p>
				<p className="text-xs text-muted-foreground">
					Recarregue quando puder. Nada do que está aberto se perde.
				</p>
			</div>
			<Button
				size="sm"
				className="h-8 shrink-0"
				onClick={() => {
					const recarregar = () => window.location.reload();
					try {
						// Quando o SW novo assume o controle, recarrega — garante o reload
						// mesmo quando o updateSW nao o dispara sozinho.
						navigator.serviceWorker?.addEventListener?.(
							"controllerchange",
							recarregar,
							{ once: true }
						);
						Promise.resolve(atualizar && atualizar(true)).catch(() => {});
					} catch {
						// sem service worker: cai no reload direto abaixo
					}
					// Rede/SW travado: garante o reload de qualquer forma.
					setTimeout(recarregar, 2500);
				}}
			>
				Recarregar
			</Button>
		</div>
	);
};

export default AtualizacaoDisponivel;
